import { useState } from "react";

const useTableParams = (defaultParams) => {
    const [params, setParams] = useState(defaultParams);

    const handleParamsChange = (params) => {
        setParams((prevParams) => ({
            ...prevParams,
            ...params,
            sortField:
                params.sortField === "organizationName"
                    ? "organization.name"
                    : params.sortField? params.sortField : prevParams.sortField,
        }));
    };
    
    return [params, handleParamsChange];
};

export default useTableParams;
